import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from 'src/app/provider/config.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-menu-detail',
    templateUrl: './menu-detail.page.html',
    styleUrls: ['./menu-detail.page.scss'],
})
export class MenuDetailPage implements OnInit {
    @Input() menu: any;
    @Input() show_actual_recipes: number = 0;
    settings: any = {}; storeData: any = {};
    customer:any;
    dummyImg = "../../assets/dummy.png";
    constructor(
        private modalCtrl: ModalController,
        private configService: ConfigService,
        private translate: TranslateService,
        private authService: AuthService
    ) { }

    async ngOnInit() {
        this.customer = await this.authService.getAuthUser();
        this.storeData = await this.configService.getStorage("appPayload");
        console.log(this.menu);
        this.configService.getAppSettings()
            .then((settingData: any) => {
                this.settings = JSON.parse(settingData);
                //console.log(this.settings);
                this.translate.setDefaultLang(this.settings.appLanguage);
                this.translate.use(this.settings.appLanguage);
            }
        );
    }
    closeModal = () => {
        this.modalCtrl.dismiss(null, 'cancel');
    }
}
